// extracted by mini-css-extract-plugin
export var addressInformationBubbleContainer = "_lt-0";
export var buttonContainer = "_lt-3";
export var cancelButton = "_lt-4";
export var headerSection = "_lt-6";
export var headerTitle = "_lt-9";
export var messageSideLeft = "_lt-1";
export var messageSideRight = "_lt-2";
export var orderNumberContainer = "_lt-7";
export var orderNumberLabel = "_lt-8";
export var submitButton = "_lt-5";